import {useState, useEffect} from "react";

export function useMarketTime() {
  const [isOpen, setIsOpen] = useState(false); // Whether the market is currently open or closed
  const [timeRemaining, setTimeRemaining] = useState(0); // Time remaining in seconds

  useEffect(() => {
    // Get the current time in EST
    const now = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
    const currentTime = new Date(now);

    // Calculate the opening and closing times
    const openingTime = new Date(currentTime);
    openingTime.setHours(9, 30, 0, 0);

    const closingTime = new Date(currentTime);
    closingTime.setHours(16, 0, 0, 0);

    // Determine whether the market is currently open or closed
    if (currentTime >= openingTime && currentTime < closingTime) {
      setIsOpen(true);
      setTimeRemaining(Math.floor((closingTime - currentTime) / 1000));
    } else {
      setIsOpen(false);
      if (currentTime < openingTime) {
        setTimeRemaining(Math.floor((openingTime - currentTime) / 1000));
      } else {
        const tomorrowOpeningTime = new Date(openingTime.getTime() + 24 * 60 * 60 * 1000);
        setTimeRemaining(Math.floor((tomorrowOpeningTime - currentTime) / 1000));
      }
    }

    // Update the time remaining every second
    const interval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          // If the timer reaches zero, update the isOpen state
          setIsOpen((prevIsOpen) => !prevIsOpen);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  function convertTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const hrsStr = hours > 0 ? `${hours}hr ` : "";
    const minsStr = minutes > 0 ? `${minutes}min ` : "";
    const secsStr = secs > 0 ? `${secs}sec` : "";

    return `${hrsStr}${minsStr}${secsStr}`;
  }

  // Convert the time remaining to a formatted string 1hr 30min 20sec
  const timeString = convertTime(timeRemaining);

  return {timeString, isOpen};
}
